import { Box } from "@mui/material";
import { Input } from "components";
import { ValidationErrors } from "@compass/core";
import { ModelPropertyBase } from "generated/openApi";
import { pillInputWrapperStyles } from "../styles/authStyles";

interface AuthFieldProps {
  name: string;
  value: string;
  onChange: (name: string, value: string) => void;
  properties: ModelPropertyBase[];
  validationErrors?: ValidationErrors;
  type?: "text" | "password";
  disabled?: boolean;
}

export const AuthField = ({
  name,
  value,
  onChange,
  properties,
  validationErrors,
  type,
  disabled,
}: AuthFieldProps) => {
  const property = properties.find((p) => p.propertyName === name);

  return (
    <Box sx={pillInputWrapperStyles}>
      <Input
        modelProperty={property}
        errors={validationErrors?.[name]}
        value={value ?? ""}
        onChange={(e) => onChange(name, e.target.value)}
        type={type}
        disabled={disabled}
        hideCount
      />
    </Box>
  );
};